import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Link } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomSelect from "../CustomComponents/CustomSelect";
import moment from 'moment';
import FormHelperText from '@mui/material/FormHelperText';

export default function ProjectDialog({ handleDialogCallback }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [projectGroups, setProjectGroupsDataSet] = React.useState([]);
    const [LockedAlert, setAlert] = React.useState(false);

    const initialValues = {
        project: '',
        projectGroupID: '',        
        startDate: '',
        endDate: '',
        IsActive: false
    };

    const validFormSchema = Yup.object({
        project: Yup
            .string('Enter a  project')
            .required(' project is required'),
        projectGroupID: Yup
            .string('Select a project group')
            .required('project group is required'),
        startDate: Yup
            .date('Enter a start date mm/dd/yyyy')
            .required('Start date is Required mm/dd/yyyy'),
        endDate: Yup
            .date('Enter an ending date mm/dd/yyyy')
            .required('End date is Required mm/dd/yyyy'),
        IsActive: Yup
            .boolean()
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            Name: values.project,            
            ProjectGroupID: values.projectGroupID,
            StartDate: moment.utc(values.startDate),
            EndDate: moment.utc(values.endDate),
            IsActive: values.IsActive,
            ProjectGroupName: projectGroups.filter(eachGroup=> eachGroup.value===values.projectGroupID)[0].label
        };
		if( ( moment.utc(values.startDate)>moment.utc(values.endDate))){
					setAlert(true);
				} else {
        handleDialogCallback(msg);        
        handleClose();
        }
    })

	const handleAlertClose = () => {
        setAlert(false);
    };
    
    const handleClickOpen = () => {
        setOpen(true);
        setRefresh(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    
    const setProjectGroupChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setProjectGroupsDataSet(choices)
    };
    
   

    React.useEffect(() => {
        if (refresh) {

            fetch('api/projectGroup', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setProjectGroupChoices(json))

            setRefresh(false);
        }
    })
    

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add Project
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Project
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Project Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>                                        
                                        <TextField
                                            name="project"
                                            id="outlined-project"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.project}
                                            error={props.touched.project && Boolean(props.errors.project)}
                                            helperText={props.touched.project && props.errors.project}
                                            label="Project"
                                        />
                                    </FormControl>
                                    
                                     <FormControl sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-ProjectGroupID">ProjectGroup Name</InputLabel>
                                        <CustomSelect
                                            name='projectGroupID'
                                            id="outlined-ProjectGroup"
                                            options={projectGroups}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.projectGroupID}
                                            error={props.touched.projectGroupID && Boolean(props.errors.projectGroupID)}
                                            helperText={props.touched.projectGroupID && props.errors.projectGroupID}
                                            label="ProjectGroup"
                                        />
                                        {props.touched.projectGroupID && Boolean(props.errors.projectGroupID) &&
													<FormHelperText error={true}>{props.errors.projectGroupID}</FormHelperText>}
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 160 }}>
                                        <TextField
                                            name="startDate"
                                            id="outlined-startDate"
                                            type="date"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.startDate}
                                            error={props.touched.startDate && Boolean(props.errors.startDate)}
                                            helperText={props.touched.startDate && props.errors.startDate}
                                            label="Start Date"
                                            InputLabelProps={{
												shrink: true,
											}}
                                        />
                                    </FormControl>
                    
                                    <FormControl sx={{ m: 1, width: 160 }}>                                        
                                        <TextField
                                            name="endDate"
                                            id="outlined-endDate"
                                            type="date"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.endDate}
                                            error={props.touched.endDate && Boolean(props.errors.endDate)}
                                            helperText={props.touched.endDate && props.errors.endDate}
                                            label="End Date"
                                            InputLabelProps={{
												shrink: true,
											}}
                                        />
                                    </FormControl>

                                    
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="IsActive"
                                            label="Active"
                                            control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="Date Alert"
                    aria-describedby="Start Date before the End Date"
                >
                    <DialogTitle id="Date Alert">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {"Start Date should be before the End Date, Please enter different time period"}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false);
                         }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>         
                
            </Dialog>
        </div>
    );
}